import type { Ref } from 'vue'
import { readPref } from '~/composables/usePersistedPref'

type MarcusLocale = 'es' | 'en'

function isMarcusLocale(value: unknown): value is MarcusLocale {
  return value === 'es' || value === 'en'
}

export default defineNuxtPlugin(async (nuxtApp) => {
  const i18n = nuxtApp.$i18n as {
    locale: Ref<string>
    setLocale?: (code: MarcusLocale) => Promise<void> | void
  }
  const localeCookie = useCookie<MarcusLocale | null>('marcus_locale', {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    path: '/',
  })

  async function applyLocale(code: MarcusLocale) {
    if (i18n.locale.value === code) return
    if (i18n.setLocale) {
      await i18n.setLocale(code)
      return
    }
    i18n.locale.value = code
  }

  if (isMarcusLocale(localeCookie.value)) {
    await applyLocale(localeCookie.value)
  }

  if (import.meta.client) {
    nuxtApp.hook('app:mounted', async () => {
      const saved = readPref('marcus_locale')
      if (!isMarcusLocale(saved)) return
      localeCookie.value = saved
      await applyLocale(saved)
    })
  }
})
